<template>
  <nav class="mobile-navigation" @click="mobileNavToggle()">
    <div
      :class="['mobile-nav-background', { 'open-nav': openBackgroundNav }]"
    ></div>
    <div class="container-hamberger">
      <div :class="['hamberger', { 'close-nav': isNavOpen }]">
        <span class="hamberger__line"></span>
        <span class="hamberger__line"></span>
        <span class="hamberger__line"></span>
      </div>
    </div>
  </nav>
  <div :class="['mobile-nav',{'active':showTextOfMobileNav}]">
    <ul class="mobile-nav-list">
      <li class="mobile-nav-list__item">
        <router-link to="/home" @click="mobileNavToggle">صفحه اصلی</router-link>
      </li>
      <li class="mobile-nav-list__item" @click="mobileNavToggle">
        <router-link to="/product">محصولات</router-link>
      </li>
      <li class="mobile-nav-list__item" @click="mobileNavToggle">
        <router-link to="/aboutUs">درباره ما</router-link>
      </li>
      <li class="mobile-nav-list__item" @click="mobileNavToggle">
        <router-link to="/contactUs">تماس با ما</router-link>
      </li>

      <li class="mobile-nav-list__item" @click="mobileNavToggle">
        <router-link to="/benefit">خواص عسل</router-link>
      </li>
      <li class="mobile-nav-list__item" @click="mobileNavToggle">
        <router-link to="/weblog">مقالات</router-link>
      </li>
    </ul>
  </div>
  <nav class="dekstop-navigation">
    <div class="nav" ref="nav">
      <ul class="nav-list">
        <div class="nav-list__item-group nav-list__item-right-group">
          <li class="nav-list__item">
            <router-link to="/home" @click="closeWeblog">صفحه اصلی</router-link>
          </li>
          <li class="nav-list__item">
            <router-link to="/product" @click="closeWeblog">محصولات</router-link>
          </li>
          <li class="nav-list__item">
            <router-link to="/aboutUs" @click="closeWeblog">درباره ما</router-link>
          </li>
        </div>

        <div class="nav-list__item-logo">
          <div class="nav-list__logo">
            <img src="../../../public/image/logo.png" alt="logo" />
          </div>
        </div>

        <div class="nav-list__item-group nav-list__item-left-group">
          <li class="nav-list__item">
            <router-link to="/contactUs" @click="closeWeblog">تماس با ما</router-link>
          </li>
          <li class="nav-list__item">
            <router-link to="/benefit" @click="closeWeblog">خواص عسل</router-link>
          </li>
          <li
            class="nav-list__item nav-list__item-log"
            :class="{'active':openWeblog}"
            ref="weblog"
          >
            <span class="nav-list__item-link-log" @click="toggleWeblog">مقالات</span>
            <ul class="nav-list-weblog" @click="closeWeblog">
              <li class="nav-list-weblog__item"  >
                <router-link to="/medicinal"
                  >عسل درمانی</router-link
                >
              </li>
              <li class="nav-list-weblog__item">
                <router-link to="/produce" 
                  >نحوه تولید عسل</router-link
                >
              </li>
              <li class="nav-list-weblog__item">
                <router-link to="/detect" 
                  >تشخیص عسل طبیعی</router-link
                >
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isNavOpen: false,
      openBackgroundNav: false,
      showTextOfMobileNav:false,
      openWeblog:false
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let nav = this.$refs.nav;
      if (window.scrollY > 10) {
        nav.classList.add("active");
      } else {
        nav.classList.remove("active");
      }
    });
  },

  methods: {
    mobileNavToggle() {
      this.isNavOpen = !this.isNavOpen;
      this.showTextOfMobileNav = !this.showTextOfMobileNav
      this.openBackgroundNav = !this.openBackgroundNav;
    },
    toggleWeblog() {
      this.openWeblog=!this.openWeblog
    },
    closeWeblog() {
      this.openWeblog=false
    }
  },
};
</script>

<style></style>
